import React, { Component } from "react";
import PropTypes from "prop-types";
import JsonSchemaForm from "react-jsonschema-form";
import Select from "react-select";
import RadioButtonGroup from "../components/RadioButtonGroup";
import FormInputNumber from "../components/FormInputNumber";
import SwitchInput from "../components/SwitchInput";
import CustomFieldTemplate from "../components/CustomFieldTemplate";
import _ from "lodash";

let myCustomForm;

class FormSkeleton extends Component {
  state = {
    hasGuarantorSwitchChecked: false
  };

  static propTypes = {
    pageContent: PropTypes.object.isRequired,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object.isRequired,
    schemaFields: PropTypes.object,
    formData: PropTypes.object.isRequired,
    onSubmit: PropTypes.func
  };

  widgets = {
    RadioButtonGroup: props => {
      return (
        <RadioButtonGroup
          groupItems={this.props.pageContent.loanTypeGroupItems}
          onChange={this.radioButtonGroupOnChange}
        />
      );
    },
    customInputWidget: props => {
      const value = props.value === undefined ? "" : props.value;
      const id = props.id.replace("root_", "");
      const name = props.id.replace("root_", "");
      const { schema } = props;
      const inputFieldOptions = {
        value: value,
        id: id,
        name: name,
        onValueChange: ({ floatValue }) =>
          this.customInputOnChange(floatValue, name),
        required: schema.required ? schema.required : false,
        className:
          "form-control" + (value !== "" && value >= 0 ? " filled-input" : ""),
        thousandSeparator: schema.thousandSeparator
          ? schema.thousandSeparator
          : ".",
        decimalSeparator: schema.decimalSeparator
          ? schema.decimalSeparator
          : ",",
        allowNegative: schema.allowNegative ? schema.allowNegative : false,
        allowLeadingZeros: schema.allowLeadingZeros
          ? schema.allowLeadingZeros
          : false,
        placeholder: schema.placeholder ? schema.placeholder : "",
        hasTooltip: schema.hasTooltip ? schema.hasTooltip : false,
        tooltipText: schema.tooltipText ? schema.tooltipText : ""
      };

      return <FormInputNumber inputFieldOptions={inputFieldOptions} />;
    },
    FormCustomSelect: props => {
      const currentValue = props.value === undefined ? "" : props.value;
      const name = props.id.replace("root_", "");
      const options = props.options.enumOptions;
      const selected =
        options.find(selected => selected.value === currentValue) || null;
      const placeholder = "Ηλικία";
      const { updateFormData, formData } = this.props;

      return (
        <Select
          className={"form-section__select-container"}
          classNamePrefix={"form-section__select-select"}
          name={name}
          options={options}
          defaultValue={selected}
          value={selected}
          placeholder={placeholder}
          onChange={selectedValue => {
            const newFormData = {
              ...formData,
              [name]: selectedValue.value
            };

            updateFormData(newFormData);
          }}
        />
      );
    },
    HasGuarantorSwitch: props => {
      const options = {
        name: props.id.replace("root_", ""),
        onChange: this.switchInputOnChange,
        labelA: "ΟΧΙ",
        labelB: "ΝΑΙ",
        checked: this.props.formData.hasOwnProperty(
          props.id.replace("root_", "")
        )
      };

      return <SwitchInput options={options} />;
    }
  };

  render() {
    const { schema, uiSchema, formData, onSubmit, pageContent } = this.props;

    return (
      <>
        <div className="form-section col-12">
          <div className="row">
            <div className="col-12 form-section__wrapper">
              <div className="row justify-content-center">
                <div className="col-12 form-section__wrapper-form">
                  <JsonSchemaForm
                    schema={schema}
                    uiSchema={uiSchema}
                    widgets={this.widgets}
                    formData={formData}
                    onSubmit={onSubmit}
                    showErrorList={false}
                    FieldTemplate={CustomFieldTemplate}
                    validate={this.validate}
                    transformErrors={this.transformErrors}
                    noHtml5Validate={true}
                    ref={form => {
                      myCustomForm = form;
                    }}
                  >
                    <div className="row pb-3 justify-content-center">
                      <div className="col-12 col-md-9 text-center">
                        <button
                          onClick={() => myCustomForm.submit()}
                          type="button"
                          className="form-submit-button text-center"
                          disabled={_.isEmpty(formData)}
                        >
                          {pageContent.submitButtonText}
                        </button>
                      </div>
                    </div>
                  </JsonSchemaForm>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  validate = (formData, errors) => {
    const { pageContent } = this.props;

    if (formData.monthlyObligations >= formData.monthlyIncome * 0.4) {
      errors.monthlyObligations.addError(
        pageContent.errorMessages["monthlyObligations"].maximum
      );
    }

    if (
      formData.monthlyGuarantorObligations >=
      formData.monthlyGuarantorIncome * 0.4
    ) {
      errors.monthlyGuarantorObligations.addError(
        pageContent.errorMessages["monthlyGuarantorObligations"].maximum
      );
    }

    return errors;
  };

  transformErrors = errors => {
    const { pageContent } = this.props;
    errors.map(error => {
      const propertyNameArray = error.property.substr(1).split(".");
      const propertyName = (propertyNameArray.length === 1
        ? propertyNameArray[0]
        : propertyNameArray[1]
      ).split("[")[0];

      error.message =
        pageContent.errorMessages[propertyName][error.name] || error.message;
    });
    return errors;
  };

  radioButtonGroupOnChange = ({ target }) => {
    const { updateFormData, formData } = this.props;
    const oldFormData = { ...formData };
    const name = target.name;
    const value = target.value;

    const newFormData = {
      ...oldFormData,
      [name]: value
    };

    updateFormData(newFormData);
  };

  customInputOnChange = (value, name) => {
    const { updateFormData, formData } = this.props;

    const newFormData = {
      ...formData,
      [name]: value
    };

    updateFormData(newFormData);
  };

  switchInputOnChange = ({ target }) => {
    const { updateFormData, formData } = this.props;
    const oldFormData = { ...formData };
    let newFormData;

    if (!oldFormData.hasOwnProperty([target.name])) {
      newFormData = {
        ...oldFormData,
        [target.name]: target.checked
      };
    } else if (
      oldFormData.hasOwnProperty([target.name]) &&
      oldFormData[target.name] === true
    ) {
      newFormData = _.omit(oldFormData, target.name);
    }

    this.setState({
      hasGuarantorSwitchChecked: !this.state.hasGuarantorSwitchChecked
    });

    updateFormData(newFormData);
  };
}

export default FormSkeleton;
